import { render, staticRenderFns } from "./CampaignUpdateForm.vue?vue&type=template&id=ca2f6518"
import script from "./CampaignUpdateForm.vue?vue&type=script&lang=js"
export * from "./CampaignUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports